import { createStore, withProps } from "@ngneat/elf";
import { withRequestsStatus } from "@ngneat/elf-requests";
import { BoostDetailsModel } from "@store/boosts/details/boostDetails.model";

export const boostDetailsStore = createStore(
  {name: "boost-details"},
  withProps<BoostDetailsModel>({}),
  withRequestsStatus(),
);
